import React from 'react';
import { TenantBranding } from '../types';

interface HeaderProps {
  branding?: TenantBranding;
  displayName?: string;
}

const Header: React.FC<HeaderProps> = ({ branding, displayName }) => {
  const logoUrl = branding?.headerLogoUrl;
  const altText = displayName || '';

  return (
    <header className="app-header">
      <div className="header-content">
        {logoUrl && (
          <img
            src={logoUrl}
            alt={altText}
            className="header-logo"
          />
        )}
      </div>
    </header>
  );
};

export default Header;
